.head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}

.head h1 {
  margin-bottom: 4px;
}

.periods {
  display: inline-flex;
  gap: 4px;
  padding: 4px;
  border: 1px solid var(--pill-line);
  border-radius: 999px;
  background: var(--pill-bg);
}

.period,
.periodActive {
  padding: 6px 14px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: var(--muted);
  font-size: 14px;
  white-space: nowrap;
}

.periodActive {
  background: var(--fill);
  background-image: var(--fill-gradient);
  color: var(--on-fill);
}

.kpis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.section {
  margin-top: 32px;
}

.section h2 {
  margin: 0 0 12px;
  font-family: var(--font-display);
  font-size: 24px;
  font-weight: 400;
}

.split {
  display: grid;
  grid-template-columns: minmax(0, 3fr) minmax(0, 2fr);
  gap: 16px;
  align-items: start;
  margin-bottom: 16px;
}

.split > :global(.card-panel) {
  margin: 0;
}

.caption {
  margin: 0 0 12px;
  color: var(--muted);
  font-size: 13px;
}

.table {
  margin-top: 12px;
  font-size: 13px;
}

.table summary {
  cursor: pointer;
  color: var(--muted);
}

@media (max-width: 1100px) {
  .split {
    grid-template-columns: 1fr;
  }
}
